/**
 * 設定項目の説明文定義
 * SettingsModalとSOAP設定ページで共有するSingle Source of Truth
 */

export interface SettingDescription {
  title: string
  description: string
}

export interface SettingSection {
  title: string
  items: {
    [key: string]: SettingDescription
  }
}

export const settingDescriptions: {
  legacyCompat: SettingSection
  speechRecognition: SettingSection
  soapOutput: SettingSection
  soapDefaultSelection: SettingSection
  otherSettings: SettingSection
  displaySettings: SettingSection
} = {
  legacyCompat: {
    title: '旧版互換設定',
    items: {
      transcription_mode: {
        title: '高速SOAP生成',
        description: 'SOAP生成時間を短縮したモデルを活用します。',
      },
      soap_prompt_version: {
        title: 'SOAP生成モデル',
        description:
          'SOAP生成に使用するモデルの系統を選択します。次の録音から反映され、元の系統にいつでも戻せます。',
      },
      use_legacy_ui: {
        title: '従来の画面',
        description:
          '従来のクラシック画面を使用します。オフにすると新しい画面に切り替わります（再読み込み後に反映）。',
      },
    },
  },
  speechRecognition: {
    title: '音声認識設定',
    items: {
      is_quick_mode: {
        title: '軽量モード',
        description:
          '軽量なモデルでSOAPを生成し、処理を高速化します（精度はやや下がる場合があります）。',
      },
      is_noise_cancelling: {
        title: 'ノイズキャンセリング',
        description:
          '隣の投薬や店内アナウンスを軽減し、文字起こし性能を向上します。',
      },
    },
  },
  soapOutput: {
    title: 'SOAP出力設定',
    items: {
      is_enrich_subjective: {
        title: 'S項目の内容を幅広に(β版)',
        description:
          'S情報をより幅広にSOAPに含めます。※ SOAPバージョン v1.x 選択時のみ有効です。',
      },
      should_enhance_soap: {
        title: 'A・OP・CPの拡充',
        description: '薬剤師の皆様が考えたであろうA・OP・CPを補足します。',
      },
      is_short_ep: {
        title: 'EPを要約',
        description:
          '投薬会話が長くなりEPも多い場合に、EPの項目数を圧縮し、SOAP視認性を向上します。',
      },
      use_soap_template: {
        title: 'SOAPテンプレート',
        description: '登録したSOAPテンプレートをSOAP生成時に展開します。',
      },
    },
  },
  soapDefaultSelection: {
    title: 'SOAPデフォルト選択',
    items: {
      is_default_selected_subjectives: {
        title: 'S（主観的情報）',
        description: 'SOAP生成時にS項目をデフォルトで選択状態にします。',
      },
      is_default_selected_objectives: {
        title: 'O（客観的情報）',
        description:
          'SOAP生成時にO項目をデフォルトで選択状態にします。薬歴側の機能でO項目を補完する場合、オフにすることで視認性が上がります。',
      },
      is_default_selected_assessments: {
        title: 'A（評価）',
        description: 'SOAP生成時にA項目をデフォルトで選択状態にします。',
      },
      is_default_selected_educational_plans: {
        title: 'EP（教育計画）',
        description:
          'SOAP生成時にEP項目をデフォルトで選択状態にします。定型文を使う場合、オフにすると便利です。',
      },
      is_default_selected_care_plans: {
        title: 'CP（ケア計画）',
        description: 'SOAP生成時にCP項目をデフォルトで選択状態にします。',
      },
      is_default_selected_observational_plans: {
        title: 'OP（観察計画）',
        description: 'SOAP生成時にOP項目をデフォルトで選択状態にします。',
      },
    },
  },
  otherSettings: {
    title: 'その他設定',
    items: {},
  },
  displaySettings: {
    title: '表示設定',
    items: {
      display_days: {
        title: '薬歴表示日数',
        description:
          '薬歴リストに表示する日数を設定します（1〜7日）。日数を少なくすると表示が高速化されます。\n最新情報反映の為にはメイン画面ドロワーメニューのリロードボタンを押す必要があります。',
      },
    },
  },
}
